//@flow
// npm imports
import { connect } from 'react-redux';

// local imports
import { setShowAlertInfo } from 'actions/appActions';
import Alert from 'components/billboard/Alert';
import type { StateProps, DispatchProps } from 'components/billboard/Alert';
import type { DispatchType, StateType } from 'types/Actions';

export default connect(
	(state: StateType): StateProps => ({
		showAlertInfo: state.appState.showAlertInfo,
		message_alerte: state.settingsState.message_alerte,
	}),
	(dispatch: DispatchType) : DispatchProps => ({
    closeAlertInfo: (raw: string) => dispatch(setShowAlertInfo(raw)),
	})
)(Alert);